import { RunDependency } from "types/generated";

import TriggeredRunsEntry from "../entries/TriggeredRunsEntry";

export const createTriggeredRunsEntry = (
  triggeredRuns: RunDependency[] | undefined,
  timestamp: number
) => {
  if (!triggeredRuns?.length) {
    return null;
  }

  return (
    <TriggeredRunsEntry key="triggeredRuns" triggeredRuns={triggeredRuns} timestamp={timestamp} />
  );
};